import React from 'react';
import {Button} from 'reactstrap';
import classNames from 'classnames';
import Icon from '../icon/FAIcon';
import AbstractReactComponent from '../AbstractReactComponent';
import './CollapsibleSidePanel.scss';

// Render mode
const COLLAPSED = 'COLLAPSED';
const EXPANDED = 'EXPANDED';
const EXPANDED_POPUP = 'EXPANDED_POPUP';

// Position
const LEFT = 'left';
const RIGHT = 'right';

const CLASS_NAME = 'collapsible-side-panel';

class CollapsibleSidePanel extends AbstractReactComponent {

    static Position = {LEFT, RIGHT};

    static propTypes = {
        position: React.PropTypes.oneOf([LEFT, RIGHT]).isRequired,
        collapsed: React.PropTypes.bool.isRequired,
        onCollapseChange: React.PropTypes.func.isRequired,
        content: React.PropTypes.func.isRequired,
        showDelay: React.PropTypes.number,  // doba před zobrazením po najetí myši
        hideDelay: React.PropTypes.number,  // doba před zobrazením po najetí myši
    };

    static defaultProps = {
        position: LEFT,
        collapsed: true,
        onCollapseChange: () => {},
        content: () => null,
        showDelay: 300,
        hideDelay: 300,
    };

    constructor(props) {
        super(props);
        this.state = {popupVisible: false};

        this.showTimer = null;
        this.hideTimer = null;
    }

    componentWillReceiveProps(props) {
        if (!props.collapsed && this.state.popupVisible) {
            this.setState({...this.state, popupVisible: false});
        }
    }

    handleToggleCollapse = () => {
        const {onCollapseChange, collapsed} = this.props;
        onCollapseChange(!collapsed);
    };

    handleShowPopup = () => {
        const {showDelay} = this.props;

        // Hide timer
        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
            this.hideTimer = null;
        }

        // Show
        if (this.showTimer) {
            clearTimeout(this.showTimer);
        }
        this.showTimer = setTimeout(
            () => {
                this.setState({...this.state, popupVisible: true});
            }, showDelay
        )
    };

    handleHidePopup = () => {
        const {hideDelay} = this.props;

        // Show timer
        if (this.showTimer) {
            clearTimeout(this.showTimer);
            this.showTimer = null;
        }

        // Hide
        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
        }
        this.hideTimer = setTimeout(
            () => {
                this.setState({...this.state, popupVisible: false});
            }, hideDelay
        )
    };

    render() {
        if (this.props.collapsed) {
            return this.renderWithMode(COLLAPSED);
        }
        return this.renderWithMode(EXPANDED);
    }

    renderWithMode(renderMode) {
        const {popupVisible} = this.state;
        const {position, onCollapseChange, content, className, hideDelay, showDelay, ...otherProps} = this.props;
        delete otherProps.collapsed; // Nechceme davat do vyctu, kolize s deklaraci stejne pojmenovane promenne nize
        delete otherProps.showDelay; // Nechceme davat do vyctu, na <div> nemaji vyznam
        delete otherProps.hideDelay; //                ----- || -----

        const collapsed = renderMode === COLLAPSED;
        const popup = renderMode === EXPANDED_POPUP;

        let header = null;
        if (!collapsed) {
            const arrowOrientation = popup ? (position === LEFT ? RIGHT : LEFT) : position;
            header = (
                <div className={`${CLASS_NAME}-header`}>
                    <Button color="link" onClick={this.handleToggleCollapse}>
                        {!popup && 'Miminalizovat panel '}
                        <Icon icon={`arrow-${arrowOrientation}`}/>
                        {popup && ' Připnout panel'}
                    </Button>
                </div>
            )
        }

        return (
            <div className={classNames(CLASS_NAME, className, position, {collapsed, popup})}
                 onMouseEnter={collapsed && this.handleShowPopup}
                 onMouseLeave={this.handleHidePopup}
                {...otherProps}>
                {header}
                <div className={`${CLASS_NAME}-content`}>
                    {content(collapsed)}
                </div>
                {collapsed && popupVisible && this.renderWithMode(EXPANDED_POPUP)}
            </div>
        );
    }

}

export default CollapsibleSidePanel;
